import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import { CohabitationDetailForm } from 'cohabitation/view-models/detail-cohabitation';
import FormEditData from './form';

interface EditDataProps {
  disabled?: boolean;
  isEditMode?: boolean;
}

const EditDataComponent = ({ disabled, isEditMode }: EditDataProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CohabitationDetailForm>();

  const onFieldEditDataChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('editDataControl', {
        ...formContext.values.editDataControl,
        [key]: value,
      });
    },
    [formContext.values.editDataControl, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-edit-data-control-content"
        id="panel-person-edit-data-control-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Dati di controllo modifica</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormEditData
          disabled={disabled}
          isEditMode={isEditMode}
          values={formContext.values.editDataControl}
          onChange={onFieldEditDataChange}
        />
      </AccordionDetails>
    </Accordion>
  );
};

EditDataComponent.displayName = 'Accordion Edit data controlo component';

const EditData = memo(EditDataComponent);

export default EditData;
